module.exports = __webpack_public_path__ + "static/media/Logo.50ea73e0.png";